<template>
  <div>
    <FileLoader v-if="employmentContractRequired" :type="AttachmentTypeEnum.KOPIA_PRACOVNEJ_ZMLUVY.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Copy of Your Employment Contract
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a copy of your valid employment contract.
    A copy of a valid employment contract is a mandatory document to verify your employment in the Slovak Republic.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        This is a mandatory document necessary to complete the application process that serves to verify your employment in the territory of the Slovak Republic.
      </template>
    </FileLoader>
    <FileLoader v-if="powerOfAttorneyRequired" :type="AttachmentTypeEnum.SPLNOMOCNENIE.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload Power of Attorney Letter
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a power of attorney letter.
    A power of attorney letter is a mandatory document when a minor's application is being submitted by another natural person.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        This is a mandatory document necessary to complete the application process when a minor's application is being submitted by another natural person
      </template>
    </FileLoader>
    <FileLoader v-if="birthCertificateRequired" :type="AttachmentTypeEnum.RODNY_LIST.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload Birth Certificate
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a copy of the child's valid birth certificate.
    The child's birth certificate is mandatory when changing health insurance providers or
    when starting a new insurance policy for a minor. If you need to insure a child of a foreign national,
    you must provide a copy of the birth certificate with a certified Slovak translation.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        This is a mandatory document necessary to complete the application process in the event of a new insurance policy or changing health insurance providers for a minor.
      </template>
    </FileLoader>
    <FileLoader v-if="residencePermitRequired" :type="AttachmentTypeEnum.POVOLENIE_NA_POBYT.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 v-if="person.isAdult" class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Residence Permit
        </h3>
        <h3 v-else class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload the Child's Residence Permit
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a residence permit due to your permanent residence outside the European Union.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        This is a mandatory document necessary to complete the application process for permanent residents of non-EU countries.
      </template>
    </FileLoader>
    <FileLoader v-if="identityDocumentRequired" :type="AttachmentTypeEnum.KOPIA_DOKLADU_TOTOZNOSTI.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Copy of Your ID
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
     To complete the application, please upload a copy of your ID. A copy of your ID is a mandatory
     document for persons with permanent residence in the EU, not in the Slovak Republic.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        This is a mandatory document necessary to complete the application process for permanent residents of EU countries other than the Slovak Republic.
      </template>
    </FileLoader>
    <FileLoader v-if="studyConfirmationRequired" :type="AttachmentTypeEnum.KOPIA_DOKLADU_OD_MSSR.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Copy of the Proof of Study Under an International Agreement Issued by the MSSR
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a copy of the proof of study under an international
    agreement issued by the Ministry of Education, Research, Development and Youth (MŠVVaŠ).
    A copy of the proof is a mandatory document for students with permanent residence outside the Slovak Republic.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        
    This is a mandatory document necessary to complete the application process issued by the Ministry of Education,
    Research, Development and Youth to students with permanent residence outside the Slovak Republic.
  
      </template>
    </FileLoader>
    <FileLoader v-if="termHealthInsuranceRequired" :type="AttachmentTypeEnum.DOKLAD_O_UKONCENI_ZP_V_ZAHRANICI.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 v-if="person.isAdult" class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Proof of Expiry / Termination of Health Insurance Abroad
        </h3>
        <h3 v-else class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Proof of Expiry / Termination of Health Insurance Abroad for a Legal Representative
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a proof that any health insurance abroad has been terminated.
    Valid proof constitutes, for instance, a certificate of termination of employment abroad, a certificate of
    termination of business or trade abroad, a certificate of termination of studies abroad, or
    a certificate of termination of long-term residence abroad. In the case of insuring a minor,
    you must provide a proof of termination of the child's legal representative's health insurance
    if you do not have a proof of termination of the child's health insurance.
    </br>
    </br>
    You can find more information about documents on the website <a href="https://www.union.sk/Navrat-zo-zahranicia" target="_blank"><u>https://www.union.sk/Navrat-zo-zahranicia</u></a>.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        
    This is a mandatory document necessary to complete the application process, which constitutes e.g.:
    <ul>
        <li>
             a certificate of termination of employment abroad
        </li>
        <li>
             a certificate of termination of business or trade abroad
        </li>
        <li>
             a certificate of termination of studies abroad
        </li>
        <li>
            or a certificate of termination of long-term residence abroad
        </li>
    </ul>
  
        <a href="https://www.union.sk/Navrat-zo-zahranicia" target="_blank">
          More Information About the Documents
        </a>
      </template>
    </FileLoader>
    <FileLoader v-if="representativeIDRequired" :type="AttachmentTypeEnum.KOPIA_DOKLADU_TOTOZNOSTI_ZAKONNEHO_ZASTUPCU.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Copy of the Legal Representative's ID
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a copy of the legal representative's ID. A copy of the ID is a mandatory document.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        
    This is a mandatory document necessary to complete the application process in the event of
    a new insurance policy or changing health insurance providers for a minor.
  
      </template>
    </FileLoader>
    <FileLoader v-if="questCountryResidenceRequired" :type="AttachmentTypeEnum.DOTAZNIK_PRE_URCENIE_STATU_BYDLISKA.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Completed Questionnaire for Determining Your Country of Permanent Residence
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a completed questionnaire for determining your country of permanent residence.
    You can download the questionnaire <a class="font-green" href="https://www.union.sk/wp-content/uploads/2021/04/Dotaznik-pre-urcenie-statu-bydliska.pdf" target="_blank">here</a>
  
        </p>
      </div>
      <template v-slot:errorLabel>
        To complete the application, please upload a completed
        <a href="https://www.union.sk/wp-content/uploads/2021/04/Dotaznik-pre-urcenie-statu-bydliska.pdf" target="_blank">
          questionnaire
        </a>.
      </template>
    </FileLoader>
    <FileLoader v-if="judicialDecisionRequired" :type="AttachmentTypeEnum.SUDNE_ROZHODNUTIE.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Court Decision
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          
    To complete the application, please upload a court decision, which is mandatory when insuring
    a child whose legal representative is another natural person or legal entity, or when insuring
    a person who is receiving institutional health services.
  
        </p>
      </div>
      <template v-slot:errorLabel>
        
    This is a mandatory document necessary to complete the application process when insuring
    a child whose legal representative is another natural or legal entity, or when insuring
    a person who is receiving institutional health services.
  
      </template>
    </FileLoader>
    <FileLoader v-if="confirmationOfBusinessLicenseRequired" :type="AttachmentTypeEnum.OSVEDCENIE_O_VZNIKU_ZIVNOSTI.name$" :person-index="personIndex" :model="model" class="mb-10" :errors="errors" >
      <div>
        <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
          Upload a Certificate of Establishing a Trade Licence in the Territory of the Slovak Republic
        </h3>

        <p class="body-2 weight-regular pb-10 pb-md-15 text-left hyperlink-color">
          To complete the application, please upload a certificate of establishing a trade licence in the territory of the Slovak Republic.
        </p>
      </div>
      <template v-slot:errorLabel>
        This is a mandatory document necessary to complete the application process, which serves to verify the provided trade licence in the territory of the Slovak Republic.
      </template>
    </FileLoader>
  </div>
</template>

<script>
import FileLoader from '@/components/FileLoader/FileLoader.vue';

export default {
  name: 'DocumentComponent',
  components: {
    FileLoader,
  },
  props: {
    errors: { type: Array, required: true },
    person: { type: Object, required: true },
    model: { type: Object, required: true },
    personIndex: { type: Number, required: true },
    requiredAttachments: { type: Array, required: true },
  },
  computed: {
    AttachmentTypeEnum() { return this.$kotlin.attachments.AttachmentTypeEnum; },
    /* Returns true if person has to upload birth certificate */
    birthCertificateRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.RODNY_LIST); },
    /* Returns true if person has to power of attorney */
    powerOfAttorneyRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.SPLNOMOCNENIE); },
    /* Returns true if person has to upload residence permit */
    residencePermitRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.POVOLENIE_NA_POBYT); },
    /* Returns true if person has to upload identity document */
    identityDocumentRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.KOPIA_DOKLADU_TOTOZNOSTI); },
    /* Returns true if person has to upload employment contract */
    employmentContractRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.KOPIA_PRACOVNEJ_ZMLUVY); },
    /* Returns true if person has to upload study confirmation */
    studyConfirmationRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.KOPIA_DOKLADU_OD_MSSR); },
    /* Returns true if person has to upload judicial decision */
    judicialDecisionRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.SUDNE_ROZHODNUTIE); },
    /* Returns true if person has to upload study confirmation */
    termHealthInsuranceRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.DOKLAD_O_UKONCENI_ZP_V_ZAHRANICI); },
    /* Returns true if person has to upload study confirmation */
    questCountryResidenceRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.DOTAZNIK_PRE_URCENIE_STATU_BYDLISKA); },
    /* Returns true if person has to upload second legal representative ID */
    representativeIDRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.KOPIA_DOKLADU_TOTOZNOSTI_ZAKONNEHO_ZASTUPCU); },
    /* Returns true if person has to upload confirmation of business licence */
    confirmationOfBusinessLicenseRequired() { return this.requiredAttachments.some((att) => att === this.AttachmentTypeEnum.OSVEDCENIE_O_VZNIKU_ZIVNOSTI); },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/global/variables";

.hyperlink-color {
  & a {
    color: $primary;
  }
}
</style>
